<script setup lang="ts">
/**
 * Halaman varian target ukuran PDF (mis. /kompres-pdf/500kb), tema v3.
 * Lihat catatan di v3/kompres-foto/[target].vue — polanya sama persis.
 */
import { VARIAN_PDF } from '~/utils/varianKompres'

/** Layout `ringan` — lihat catatan di pages/kompres-foto/index.vue. */
definePageMeta({ layout: 'ringan' })

const route = useRoute()
const situs = useSitusUrl()

const slug = String(route.params.target || '')
const varian = VARIAN_PDF[slug]

if (!varian) {
  throw createError({ statusCode: 404, statusMessage: 'Halaman tidak ditemukan', fatal: true })
}

const path = `/kompres-pdf/${slug}`

pakaiSeo({
  judul: varian.judul,
  deskripsi: varian.deskripsi,
  path,
  jsonLd: [
    jsonLdAplikasi({
      nama: varian.h1,
      deskripsi: varian.deskripsi,
      url: situs + path,
      harga: 0
    }),
    jsonLdFaq(varian.faq),
    jsonLdRemah(situs, [
      ['Beranda', '/'],
      ['Kompres PDF', '/kompres-pdf'],
      [`${varian.targetKb} KB`, path]
    ])
  ]
})

const lainnya = Object.entries(VARIAN_PDF)
  .filter(([s]) => s !== slug)
  .map(([s, v]) => ({ ke: `/kompres-pdf/${s}`, label: `${v.targetKb} KB` }))
</script>

<template>
  <RinganVarianKompres
    jenis="pdf"
    :varian="varian!"
    induk-path="/kompres-pdf"
    induk-nama="Kompres PDF"
  >
    <template #tautan-lain>
      <div class="flex flex-wrap gap-3">
        <RinganTombol
          v-for="l in lainnya"
          :key="l.ke"
          variant="secondary"
          size="md"
          :to="l.ke"
        >Kompres PDF jadi {{ l.label }}</RinganTombol>
      </div>
      <p class="ca-caption text-muted mt-5">
        Butuh foto?
        <NuxtLink
          to="/kompres-foto"
          class="text-brand font-semibold underline underline-offset-2"
        >Kompres foto ke ukuran KB</NuxtLink>.
      </p>
    </template>
  </RinganVarianKompres>
</template>
